import { useState } from "react";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import CardActionableButton from "../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import ICONS from "../../../assets/Icons";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";

const ChannelPasteLogoURL = ({ copyLogoURL, setCopyLogoURL, logoUrl }) => {
  const [copiedNotificationId, setCopiedNotificationId] = useState(false);

  return (
    <div className="flex flex-col global-card-create gap-gap-md h-full">
      <TitleSubtitlePair
        title={TEXT?.ADD_XPENTRA_LOGO}
        subtitle={TEXT?.XPENTRA_LOGO_WEBHOOK_INSTRUCTIONS}
        isBold={true}
        variant="md"
        titleColor="text-primary"
      />

      <div className="flex justify-between gap-gap-sm items-start">
        <TitleSubtitlePair
          title={linkIdentifier(logoUrl)}
          subtitle={`${TEXT?.LOGO} ${TEXT?.URL.toUpperCase()}`}
          isBold={false}
          variant="sm"
          titleColor="text-primary"
        />

        <CardActionableButton
          handleFunction={async () => {
            await navigator.clipboard.writeText(logoUrl);
            setCopiedNotificationId(true);
            setCopyLogoURL(TEXT?.COPIED);
            setTimeout(() => {
              setCopiedNotificationId(false);
              setCopyLogoURL(TEXT?.COPY_TO_CLIPBOARD);
            }, IntervalConfiguration.intervalMedium);
          }}
          icon={
            copiedNotificationId ? ICONS.SELECTED_WITH_GREEN_CIRCLE : ICONS.COPY
          }
          title={copyLogoURL}
          bgColor={"var(--primary-nav)"}
        />
      </div>
    </div>
  );
};

export default ChannelPasteLogoURL;
